import { render, staticRenderFns } from "./CustomerUnsubscribeOptions.vue?vue&type=template&id=efde7e98&"
import script from "./CustomerUnsubscribeOptions.vue?vue&type=script&lang=js&"
export * from "./CustomerUnsubscribeOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports